<template>
  <v-container
    fill-height
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="6"
        md="5"
        lg="4"
      >
        <v-card>
          <v-card-title>
            <h3 style="font-weight:300">
              Job Code
            </h3>
          </v-card-title>
          <v-card-text
            class="px-5 pt-3"
            style="font-size:18px;"
          >
            Your production manager may have linked a job code that
            correlates to your current job. Type in that code below, and
            we will redirect you to the job specific form.
          </v-card-text>
          <v-form ref="form">
            <v-card-actions>
              <v-row
                align="center"
                justify="space-around"
                no-gutters
                class="pb-3"
                wrap
              >
                <v-col
                  cols="12"
                >
                  <v-row
                    align="center"
                    justify="space-around"
                    no-gutters
                    class="pb-3"
                    wrap
                  >
                    <v-col cols="auto">
                      <PincodeInput
                        :value="jobCode"
                        @input="pinInput"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    id="landing-contact-us"
                    :loading="isSubmitting"
                    color="primary elevation-0"
                    @click="submit"
                  >
                    Submit
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PincodeInput from '../components/PincodeInput.vue';
import rules from '../utils/rules';
import { getJobFromCode, getJobFromArtCode } from '../services/jobs';

export default {
  components: {
    PincodeInput,
  },
  data() {
    return {
      rules,
      isSubmitting: false,
      jobCode: '',
    };
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) {
        this.scrollToFirstFormError();
      }
      this.isSubmitting = true;
      try {
        const { data: job } = await getJobFromCode(this.jobCode);
        if (job.payrollProvider.id === 3) {
          this.$router.push({ name: 'submission-invoice', params: { hash: job.hash } });
        } else {
          this.$router.push({ name: 'submission', params: { hash: job.hash } });
        }
      } catch (e) {
        try {
          const { data } = await getJobFromArtCode(this.jobCode);
          this.$router.push({ name: 'submission-art', params: { hash: data.hash } });
        } catch {
          this.isSubmitting = false;
          this.$emit('snackbar', { text: 'Job code did not work. Either code was incorrect or job is over.', color: 'red' });
        }
      }
    },
    scrollToFirstFormError() {
      let firstInvalidInput;
      this.$refs.form.inputs.some((input) => {
        if (!input.valid) {
          firstInvalidInput = input;
        }
        return !input.valid;
      });
      if (firstInvalidInput) {
        this.$vuetify.goTo(firstInvalidInput.$el);
      }
    },
    async pinInput(val) {
      this.jobCode = val;
      if (this.jobCode.length >= 4) {
        await this.submit();
      }
    },
  },
};
</script>

<style>

</style>
